export const buttonStyle: any = {
    green: {
        backgroundColor: 'primary.dark',
        color: 'primary.contrastText',
        ':hover': {
            backgroundColor: 'var(--sos-hover)',
        }
    },
    blue: {
        backgroundColor: 'secondary.main',
        color: 'secondary.contrastText',
        ':hover': {
            backgroundColor: 'secondary.dark'
        }
    },
    yellow: {
        backgroundColor: 'tertiary.main',
        color: 'tertiary.contrastText',
        ':hover': {
            backgroundColor: 'var(--background-orange)',
        }
    },
    white: {
            backgroundColor: 'white',
            color: 'var(--primary-text)',
            ':hover': {
                backgroundColor: '#D3D3D3',
            }
        }
}
